import React from 'react';
import { Grid } from '@mui/material';

import { Company } from '../../../models/company.model';
import { Supplier } from '../../../models/supplier.model';
import SupplierDetailsCard from '../../../common/supplier-details-card/SupplierDetailsCard';
import BankDetailsCard from '../../../common/bank-details-card/BankDetailsCard';

interface DetailsTabsProps {
  company: Company;
  supplier: Supplier;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ supplier }) => {
  const bankDetails = supplier?.supplier_bank_details;
  return (
    <>
      <Grid container wrap='wrap' rowGap={2}>
        <Grid size={{ xs: 12 }}>
          <SupplierDetailsCard supplier={supplier} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          {bankDetails &&
            bankDetails.length > 0 &&
            bankDetails.map((bank) => (
              <Grid key={bank?.id}>
                <BankDetailsCard
                  bank={bank}
                  supplierId={supplier?.id}
                  isSupplierBankDetails={true}
                />
              </Grid>
            ))}
          {bankDetails.length === 0 && (
            <Grid>
              <BankDetailsCard isSupplierBankDetails={true} supplierId={supplier?.id} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default DetailsTabs;
